import {
  BPanel,
  Progress,
  Icon,
  Button,
  ListGroupItem,
  ListGroup,
} from '@sketchpixy/rubix';
import { Roles } from 'roles';
import { Link, withRouter } from 'react-router';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import { Base64 } from 'meteor/base64';
import { HTTP } from 'meteor/http';

import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Reservations } from '../../collections/reservations/reservations';

import { PlanningAnnuleModal } from './PlanningAnnuleModal';
import { PlanningConfirmModal } from './PlanningConfirmModal';
import { PlanningClotureModal } from './PlanningClotureModal';
import { FlightTypeColor } from '../reservations/components/flightTypeColorComponent';

import { NotifySmsComponent } from './component-notify-sms';
import { getAvailabilityTotalCount, getReservedCount } from '../../helpers/availabilities';

import { Reactive } from '../common/Reactive.mixin.js';

@withRouter
export class PlanningPeriod extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
	}

	componentDidMount() {
	}

	componentWillReceiveProps() {
		this.fetchFlight();
		this.fetchStats();
		this.setObservers();
	}

	componentWillUnmount() {
		this._flightsHandle && this._flightsHandle.stop();
	}

	setObservers() {
		let projection = {
			period: this.props.period,
			date: moment(this.props.date).startOf("day").toDate()
		}
		this._flightsHandle && this._flightsHandle.stop();
		this._flightsHandle = Flights.find(projection).observe({
			changed: this.fetchFlight.bind(this)
		});
	}

	scheduleFlight() {
		let projection = {
			$elemMatch: {
				startDate: {$lte: this.props.date},
				endDate: {$gte: this.props.date},
				isAvailable: true,
				period: this.props.period,
				place: "anjou"
			}
		};
		const isAnjou = Meteor.users.findOne({"_id": Meteor.userId(), "profile.availabilities": projection});

		if (!isAnjou) projection["$elemMatch"]["place"] = "nantes";
		const pilotId = Roles.userHasRole(Meteor.userId(), "pilot")
		&& !Flights.findOne({
			date: moment(this.props.date).startOf('day').toDate(),
			period: this.props.period,
			pilotId: Meteor.userId()
		}) && Meteor.users.findOne({"_id": Meteor.userId(), "profile.availabilities": projection}) ? Meteor.userId() : null;

		Flights.insert({
			date: moment(this.props.date).startOf('day').toDate(),
			period: this.props.period,
			place: isAnjou ? 'anjou' : 'nantes',
			pilotId: pilotId,
			status: "preparing"
		}, ((err, _id) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

			this.props.router.push('/planning/flights/' + _id);
		}).bind(this));
	}

	openPopUp(urlToOpen) {
	  var popup_window=window.open(urlToOpen,"myWindow","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
	  try {
	    popup_window.focus();
	  }
	  catch (e) {
	    alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
	  }
	}

	downloadDDV() {
		let flight = this.state.flight;
        let reservations = Reservations.find({_id: {$in: flight.reservationIds }}, {fields: {"id_billet": 1, "passengers": 1, "payment": 1}}).fetch();

        _.each(reservations, (reservation) => {
            reservation.passengers = reservation.getPassengers();
            console.log('getPassengers', reservation.getPassengers());
            reservation.payementMode = reservation.getPayment();
        });

				let selectedMontgolfiere = Montgolfieres.findOne(flight.montgolfiereId);
				let montgolfieresDatas = Montgolfieres.find({ $or: [{online: true}, {_id: flight.montgolfiereId}]}).fetch()

				let montgolfieres = [];
				_.each(montgolfieresDatas, (montgolfiere) => {
					montgolfieres.push({
						'maxWeight': montgolfiere.maxWeight,
						'defaultWeight': montgolfiere.defaultWeight,
						'emptyWeight': montgolfiere.emptyWeight,
						'name' : montgolfiere.name,
						'archived': montgolfiere.archived
					});
				});

				let pilote = Meteor.users.findOne(flight.pilotId);

        let data = {
					montgolfieres : montgolfieres,
					selectedMontgolfiere : {
							'defaultWeight': selectedMontgolfiere.defaultWeight,
							'maxWeight': selectedMontgolfiere.maxWeight,
							'name': selectedMontgolfiere.name,
						},
						reservations : reservations,
            temp : flight.temp,
            date: moment(flight.date).format('DD/MM/YYYY'),
            period: flight.period,
            place: flight.place,
            pilote: {
							'firstName': pilote.profile.firstName,
							'lastName': pilote.profile.lastName,
							'weight': pilote.profile.weight,
						},
            meetPoint: flight.getMeetPoint(),
            meetingDate: moment(flight.meetingDate).format('HH:mm')
        }

				console.log('data', data);

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=vol', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

    }

	editFlight() {
		if (!this.state.flight)
			return ;

		this.props.router.push('/planning/flights/' + this.state.flight._id);
	}

	fetchStats() {
		const stats = {
			anjou: {
				reservedCount: getReservedCount(this.props.date, "anjou", this.props.period),
				totalCount: getAvailabilityTotalCount(this.props.date, "anjou", this.props.period)
			},
			nantes: {
				reservedCount: getReservedCount(this.props.date, "nantes", this.props.period),
				totalCount: getAvailabilityTotalCount(this.props.date, "nantes", this.props.period)
			}
		};

		stats.anjou.percent = stats.anjou.reservedCount / stats.anjou.totalCount * 100
		if (stats.anjou.percent == 0) stats.anjou.percent = 0.1;
		if (_.isNaN(stats.anjou.percent)) stats.anjou.percent = 0.1;

		stats.nantes.percent = stats.nantes.reservedCount / stats.nantes.totalCount * 100
		if (stats.nantes.percent == 0) stats.nantes.percent = 0.1;
		if (_.isNaN(stats.nantes.percent)) stats.nantes.percent = 0.1;

		this.setState({ stats });
	}

	fetchFlight() {
		const flight = Flights.findOne({
			date: moment(this.props.date).startOf('day').toDate(),
			period: this.props.period,
			pilotId: Meteor.userId(),
			status: { $in: ["preparing", "prepared", "cancelled", "validated"] }
		});

		this.setState({ flight });
	}

	flights() {
		let projection = {
			period: this.props.period,
			date: moment(this.props.date).startOf("day").toDate()
		}
		if (this.props.place) projection["place"] = this.props.place;

		return Flights.find(projection).fetch();
	}

	reservations(place) {

		let projection = {
			'place': place,
			'scheduledAt': {$gte: moment(this.props.date).startOf("day").subtract(2, 'hours').toDate(), $lte: moment(this.props.date).endOf("day").toDate()},
      $or: [{'periodTime': this.props.period},{'period': this.props.period}]
		}
		if (this.props.place && this.props.place !== place) return [];

    let reservations = Reservations.find(projection).fetch();

    let results = _.reject(reservations, (reservation) => {
      if(reservation.period && reservation.periodTime) {
        if(reservation.periodTime != this.props.period) {
          return true;
        }
      }
    });

    return results;
	}

  totalWeight(place) {
    let totalWeightReservations = 0;
    let totalWeightMontgolfieres = 0;

    this.reservations(place).map((reservation) => {
      totalWeightReservations += reservation.totalWeight();
    });

    this.montgolfieres(place).map((montgolfiere) => {
      totalWeightMontgolfieres += montgolfiere.defaultAllowedWeight;
    });

    return totalWeightReservations + '/' + totalWeightMontgolfieres;
  }

	pilots(place) {
		let projection = {
			$elemMatch: {
				startDate: {$lte: this.props.date},
				endDate: {$gte: this.props.date},
				isAvailable: true,
				period: this.props.period,
				place
			}
		};
		if (this.props.place && this.props.place !== place) return [];

		return Meteor.users.find({"profile.availabilities": projection}).fetch();
	}

	montgolfieres(place) {
		let projection = {
			$elemMatch: {
				startDate: {$lte: this.props.date},
				endDate: {$gte: this.props.date},
				isAvailable: true,
				period: this.props.period,
				place
			}
		};
		if (this.props.place && this.props.place !== place) return [];

		return Montgolfieres.find({"availabilities": projection}).fetch();
	}

	render() {

		this.state.flight = Flights.findOne({
			date: moment(this.props.date).startOf('day').toDate(),
			period: this.props.period,
			pilotId: Meteor.userId(),
			status: { $in: ["preparing", "prepared", "cancelled", "validated"] }
		}, {sort: {createdAt: -1, limit: 1}});

		return (
			<BPanel header={this.props.period == "morning" ? "Matin" : "Soir"} className="planning-period">
				{ this.state.stats &&
					<div className="availability-progress-container">
						{(!this.props.place || this.props.place == "anjou") &&
							<div>
								<p>{this.state.stats.anjou.reservedCount + "/" + this.state.stats.anjou.totalCount + " places"} - {this.totalWeight('anjou')}KG</p>
								<Progress striped bsStyle="info" value={this.state.stats.anjou.percent} />
							</div>
						}

						{(!this.props.place || this.props.place == "nantes") &&
							<div>
								<p>{this.state.stats.nantes.reservedCount + "/" + this.state.stats.nantes.totalCount + " places"} - {this.totalWeight('nantes')}KG</p>
								<Progress striped bsStyle="warning" value={this.state.stats.nantes.reservedCount / this.state.stats.nantes.totalCount * 100} />
							</div>
						}

						<hr/>
					</div>
				}

				{(this.state.flight && this.state.flight.status == "pending") &&
					<PlanningClotureModal></PlanningClotureModal>
				}

				{(Roles.userHasPermission(Meteor.userId(), "flights.insert", Meteor.userId(), { date: moment(this.props.date).startOf('day').toDate(), period: this.props.period, pilotId: Meteor.userId(), status: "preparing" })) &&
					<Button bsStyle="primary" onClick={::this.scheduleFlight}>Programmer un vol</Button>
				}

        {this.state.flight && this.state.flight.status != 'validated' &&
				      <Button bsStyle="primary" onClick={::this.editFlight}>Editer mon vol</Button>
        }

        {this.state.flight && this.state.flight.status == 'preparing' && this.state.flight.validToFlight &&
					<PlanningConfirmModal flight={this.state.flight}></PlanningConfirmModal>
				}

				{this.state.flight && Roles.userHasPermission(Meteor.userId(), "flights.enclose", Meteor.userId(), this.state.flight) &&
					<span>
						<PlanningClotureModal flight={this.state.flight}></PlanningClotureModal>
					</span>
				}

				{this.state.flight && this.state.flight.status == 'prepared' &&
					<Button bsStyle="info" onClick={::this.downloadDDV}>Télécharger mon dossier de vol</Button>
				}

				{this.state.flight && this.state.flight.status !== "cancelled" && this.state.flight.status !== "validated"
					 && this.state.flight.validToFlight &&
					<PlanningAnnuleModal flight={this.state.flight} onCancel={() => this.setState({ flight: { status: "cancelled" } })}></PlanningAnnuleModal>
				}

				{this.state.flight && this.state.flight.status == 'cancelled' &&
					<span>
						<Button bsStyle="warning" disabled>Annulé</Button> &nbsp;
						<Button bsStyle="primary" onClick={::this.scheduleFlight}>Programmer un vol</Button>
					</span>
				}

				{this.state.flight && this.state.flight.status == 'validated' &&
					<Button bsStyle="success" disabled>Clôturé</Button>
				}

				<hr/>
				<strong>Vols programmés :</strong>
				{this.flights().map((flight) => {
					return (
						<ListGroup key={flight._id}>
							{ flight.getPilote() &&
								<ListGroupItem bsStyle={ flight.place == "anjou" ? "info" : "warning" }>Pilote : { flight.getPilote().profile.firstName + " " + flight.getPilote().profile.lastName }</ListGroupItem>
							}
							{flight.getMontgolfiere() &&
								<ListGroupItem bsStyle={ flight.place == "anjou" ? "info" : "warning" }>Ballon : { flight.getMontgolfiere().name }</ListGroupItem>
							}
							{flight.getReservations() && flight.getReservations()[0] && flight.getReservations().map((reservation) => {
								if(!reservation)
									return (<span></span>);
								return (
									<Link to={"reservations/" + reservation._id} key={reservation._id}>
										<ListGroupItem bsStyle={ flight.place == "anjou" ? "info" : "warning" }>
											{ reservation.id_billet } - { reservation.getPassengers().length }PAX - { reservation.totalWeight() }KG
											{reservation.getFlightType() &&
												<FlightTypeColor flightType={reservation.getFlightType()}/>
											}
											<NotifySmsComponent reservation={reservation}/>
										</ListGroupItem>
									</Link>
								);
							})}

							<ListGroupItem bsStyle={ flight.place == "anjou" ? "info" : "warning" }>
								Statut : { flight.getStatus() }
							</ListGroupItem>

							{ Roles.userHasPermission(Meteor.userId(), "flights.prepare", Meteor.userId(), flight) &&
								<Link to={"planning/flights/" + flight._id}>
									<ListGroupItem className="list-group-item-primary">
										<Icon glyph="glyphicon-edit" />
											&nbsp; Editer
									</ListGroupItem>
								</Link>
							}
						</ListGroup>
					);
				})}
				<hr/>
				<strong>Réservations :</strong>
				<ListGroup>
					{this.reservations("anjou").map((reservation) => {
						reservation.getFlight();
						if(!reservation)
							return (<span></span>);
						return (
							<Link to={"reservations/" + reservation._id} key={reservation._id}>
								<ListGroupItem disabled={reservation.getFlight()} bsStyle="info">
									{ reservation.id_billet } - { reservation.getPassengers().length }PAX - { reservation.totalWeight() }KG
									{reservation.getFlightType() &&
										<FlightTypeColor flightType={reservation.getFlightType()}/>
									}
									</ListGroupItem>
							</Link>
						);
					}) }
					{this.reservations("nantes").map((reservation) => {
						if(!reservation)
							return (<span></span>);
						return (
							<Link to={"reservations/" + reservation._id} key={reservation._id}>
								<ListGroupItem disabled={reservation.getFlight()} bsStyle="warning">
									{ reservation.id_billet } - { reservation.getPassengers().length }PAX - { reservation.totalWeight() }KG
									<FlightTypeColor flightType={reservation.getFlightType()}/>
								</ListGroupItem>
							</Link>
						);
					}) }
				</ListGroup>
				<hr/>
				<strong>Pilotes :</strong>
				<ListGroup>
					{this.pilots("anjou").map((pilot) => {
						return <ListGroupItem disabled={pilot.flightScheduledAt(this.props.date, this.props.period)} bsStyle="info" key={pilot._id}>{ pilot.profile.firstName + ' ' + pilot.profile.lastName }</ListGroupItem>
					}) }
					{this.pilots("nantes").map((pilot) => {
						return <ListGroupItem disabled={pilot.flightScheduledAt(this.props.date, this.props.period)} bsStyle="warning" key={pilot._id}>{ pilot.profile.firstName + ' ' + pilot.profile.lastName }</ListGroupItem>
					}) }
				</ListGroup>
				<hr/>
				<strong>Ballons :</strong>
				<ListGroup>
					{this.montgolfieres("anjou").map((montgolfiere) => {
						return (
							<ListGroupItem disabled={montgolfiere.flightScheduledAt(this.props.date, this.props.period)} bsStyle="info" key={montgolfiere._id}>{ montgolfiere.name }</ListGroupItem>
						)
					}) }
					{this.montgolfieres("nantes").map((montgolfiere) => {
						return (
							<ListGroupItem disabled={montgolfiere.flightScheduledAt(this.props.date, this.props.period)} bsStyle="warning" key={montgolfiere._id}>{ montgolfiere.name }</ListGroupItem>
						)
					}) }
				</ListGroup>
			</BPanel>
		);
	}
}

PlanningPeriod.propTypes = {
	date: React.PropTypes.instanceOf(Date),
	period: React.PropTypes.string,
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningPeriod.js
 **/